export default "__VITE_ASSET__TIXXDJVQ__"